export const fmtDuree = (sec) => {
  if (sec == null) return "—";
  sec = Math.max(0, Math.floor(sec));
  const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
  if (h) return `${h}h ${String(m).padStart(2, "0")}m`;
  if (m) return `${m}m ${String(s).padStart(2, "0")}s`;
  return `${s}s`;
};

export const fmtMin = (min) => (min == null ? "—" : fmtDuree(min * 60));

export const fmtNum = (v, dec = 0) =>
  v == null ? "—" : Number(v).toLocaleString("fr-FR", { minimumFractionDigits: dec, maximumFractionDigits: dec });

export const fmtPct = (v, dec = 1) => (v == null ? "—" : `${Number(v).toLocaleString("fr-FR", { minimumFractionDigits: dec, maximumFractionDigits: dec })} %`);

export const fmtHeure = (iso) =>
  iso ? new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "—";

export const fmtDateHeure = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";

export const fmtDate = (d) =>
  d ? new Date(d + (d.length === 10 ? "T00:00:00" : "")).toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "short" }) : "—";

export const trsTone = (v) => (v == null ? "none" : v >= 75 ? "ok" : v >= 60 ? "warn" : "crit");

export const TONE_TEXT = { ok: "text-emerald-400", warn: "text-amber-400", crit: "text-red-400", none: "text-muted-foreground" };
export const TONE_BG = { ok: "bg-emerald-500", warn: "bg-amber-500", crit: "bg-red-500", none: "bg-slate-600" };

// « Aujourd'hui » = la date dans le FUSEAU DE L'USINE (jamais l'UTC : entre 20:00 et minuit à Toronto, la date
// UTC est déjà celle de demain et le tableau de bord pointait vers une journée qui n'a pas commencé).
// Le fuseau est fourni par le serveur (AppLayout → /fuseau-usine) ; à défaut, fuseau du navigateur.
let _fuseauUsine = null;
export const setFuseauUsine = (tz) => { _fuseauUsine = tz || null; };
const _jourDans = (tz) => {
  const p = new Intl.DateTimeFormat("en-CA", { timeZone: tz || undefined, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date());
  const g = (t) => p.find((x) => x.type === t).value;
  return `${g("year")}-${g("month")}-${g("day")}`;
};
export const todayIso = () => {
  try { return _jourDans(_fuseauUsine); } catch { return _jourDans(null); }
};
// Calcul calendaire pur en UTC : indépendant du fuseau du navigateur (l'ancienne version se décalait d'un jour
// dans les fuseaux à l'est de l'UTC).
export const addDays = (iso, n) => { const [y, m, d] = iso.split("-").map(Number); return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10); };
